export default __webpack_public_path__ + "static/media/26_tag_lounge.6351a701.svg";